import React from "react";

import Button, { ButtonTypes } from "../../../../components/Button";
import {
  CardHeader,
  CardTitle,
  DefinitionList,
  DetailCard,
  Pill,
  StatusNote,
} from "../../styles";
import { formatInterval, formatObservedAt } from "../../utils/format";
import { labelOfStatus, toneOfStatus } from "../../utils/status";
import { OUTCOME_LABELS } from "../constants";
import { SchedulerDetailProps } from "../types";
import { describeStatus } from "../utils/describeStatus";

export const SchedulerDetail: React.FC<SchedulerDetailProps> = ({
  scheduler,
  detailRef,
  isStacked,
  onBackToList,
}) => {
  const {
    name,
    status,
    cronPattern,
    timezone,
    expectedIntervalMinutes,
    lastRunAt,
    lastOutcome,
    lastSuccessAt,
    lastFailureAt,
    lastFailureErrorName,
  } = scheduler;
  const tone = toneOfStatus(status);
  const note = describeStatus(scheduler);
  const outcome = lastOutcome ? OUTCOME_LABELS[lastOutcome] : "None recorded";

  return (
    <DetailCard ref={detailRef} tabIndex={-1} aria-label="Selected scheduler">
      {isStacked && (
        <Button type={ButtonTypes.link} size="small" onClick={onBackToList}>
          Back to schedulers
        </Button>
      )}
      <CardHeader>
        <CardTitle>{name}</CardTitle>
        <Pill $tone={tone}>{labelOfStatus(status)}</Pill>
      </CardHeader>
      {note && <StatusNote $tone={tone}>{note}</StatusNote>}
      <DefinitionList>
        <dt>Last outcome</dt>
        <dd>{outcome}</dd>
        <dt>Last recorded run</dt>
        <dd>{formatObservedAt(lastRunAt)}</dd>
        <dt>Last success</dt>
        <dd>{formatObservedAt(lastSuccessAt)}</dd>
        <dt>Last failure</dt>
        <dd>{formatObservedAt(lastFailureAt)}</dd>
        {lastFailureErrorName && (
          <>
            <dt>Failure error</dt>
            <dd>{lastFailureErrorName}</dd>
          </>
        )}
        <dt>Longest expected gap</dt>
        <dd>{formatInterval(expectedIntervalMinutes)}</dd>
        <dt>Schedule</dt>
        <dd>{cronPattern}</dd>
        <dt>Timezone</dt>
        <dd>{timezone}</dd>
      </DefinitionList>
    </DetailCard>
  );
};
